/**
 * A score as text in its band colour, with a decorative dot (a number, or "Not scored"): shared by the idea
 * screens and the dashboard. Colour is never the only signal.
 */

export type Band = 'high' | 'mid' | 'low';

/** ≥80 strong, 60–79 conditional, below 60 weak: the same cut-offs as the verdict wording. */
export function bandOf(score: number): Band {
  if (score >= 80) return 'high';
  if (score >= 60) return 'mid';
  return 'low';
}

const BAND_LABEL: Record<Band, string> = { high: 'strong', mid: 'moderate', low: 'weak' };

export function formatScore(value: number | null | undefined): string {
  if (value === null || value === undefined) return 'Not scored';
  return Number.isInteger(value) ? String(value) : value.toFixed(1);
}

/** A score as text in its band colour, with a decorative dot. */
export function ScoreValue({ value }: { value: number | null | undefined }) {
  if (value === null || value === undefined) {
    return (
      <span className="hint">Not scored</span>
    );
  }
  const band = bandOf(value);
  return (
    <span className={`score score-band-${band}${value >= 90 ? ' is-top' : ''}`} title={`${BAND_LABEL[band]}`}>
      <span className="score-dot" aria-hidden="true" />
      {formatScore(value)}
    </span>
  );
}
